/** Shared public-web typography for text, password and calculator fields. */
export const getWebTextFieldSx = (scale: 'regular' | 'large' = 'regular') => {
    const large = scale === 'large';
    return {
        '& .MuiInputBase-root': {
            paddingInline: '0.7rem',
            minHeight: large ? '7.2rem' : '5.6rem',
            borderRadius: '99rem',
            background: 'transparent',
        },
        '& input': {
            boxSizing: 'border-box',
            height: large ? '7.2rem' : '5.6rem',
            padding: large ? '2.9rem 2rem 1.1rem' : '2.5rem 2rem 0.7rem',
            fontSize: large ? '2.1rem' : '1.5rem',
            lineHeight: large ? '2.8rem' : '2.4rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            color: '#26205f !important',
        },
        '& label, & label.Mui-focused, & label.Mui-error': { color: '#72645a !important' },
        '& label': {
            transform: 'none',
            letterSpacing: 0,
            fontFamily: 'inherit',
            fontWeight: 400,
            transition: 'top 200ms ease, font-size 200ms ease, color 200ms ease',
            top: large ? '2.4rem' : '1.7rem',
            left: '2.7rem',
            fontSize: '1.6rem',
            lineHeight: '2.2rem',
        },
        '& label.Mui-focused, & label.MuiFormLabel-filled, & label.MuiInputLabel-shrink': {
            top: large ? '1.2rem' : '0.9rem',
            fontSize: '1.4rem',
            lineHeight: '1.8rem',
        },
        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitTextFillColor: '#26205f !important',
            WebkitBoxShadow: '0 0 0 1000px #fdf7f2 inset !important',
        },
    };
};
